import { Length } from "../baseQuantities/length";
import { Flow } from "../baseQuantities/flow";
import { Velocity } from "../baseQuantities/velocity";
import {
  AppData,
  CalcMode,
  Calculator,
} from "../../interface/functionalityInterface";
import standardFlowRateFigure from "../../img/calc-figure-flowRate-standard.svg";

const standardMode: CalcMode = {
  id: "001standard",
  name: "standard",
  baseQuantities: [
    { ...Flow },
    { ...Velocity },
    { ...Length, name: "diameter", selectedUnit: "mm", symbol: "D" },
  ],
  equation: "Q=v*A",
  figure: standardFlowRateFigure,
};

export const flowrateCalc: Calculator = {
  type: AppData.CALCULATOR,
  updatedAt: "2022-07-26",
  name: "flow rate",
  branch: "Fluids",
  difficulty: "intermediate",
  inputs: [standardMode],
  calculate: [
    {
      name: "standard",
      equations: [
        {
          target: "flow",
          expression: "(velocity) * (pi/4 * (diameter)^2)",
        },
        {
          target: "diameter",
          expression: "root(4/pi * (flow) / (velocity))",
        },
        {
          target: "velocity",
          expression: "(flow) / (pi/4 * (diameter)^2)",
        },
      ],
    },
  ],
};
